<template>
    <Button label="Inserir Anexo" icon="pi pi-plus" iconPos="left" class="p-button mr-2" v-if="$temAcessoView('RM-CONV-EXEC-DIRETA-20')" />
</template>
